export default {
        apiKey: "AIzaSyCqSrOLyvywmw9l0BO9UejncuyUIjsV7lw",
        authDomain: "shop2-822cc.firebaseapp.com",
        projectId: "shop2-822cc",
        storageBucket: "shop2-822cc.appspot.com",
        messagingSenderId: "304518271939",
        appId: "1:304518271939:web:ff51f811e93bff7619a376",
        measurementId: "G-H4249W8SK7"
}